<script setup lang="ts">
import { NxtInput, NxtTextarea } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <section>
      <div class="row">
         <NxtInput
            name="job-board_settings_meta_title"
            :label="$t('job-board.settings.meta_data.title')"
            :description="$t('job-board.settings.meta_data.title_description')"
            v-model="jobBoard.meta_data.title"
         />
      </div>
      <div class="row">
         <NxtTextarea
            name="job-board_settings_meta_description"
            :label="$t('job-board.settings.meta_data.description')"
            :description="$t('job-board.settings.meta_data.description_description')"
            v-model="jobBoard.meta_data.description"
         />
      </div>
      <div class="row">
         <NxtInput
            name="job-board_settings_meta_about"
            :label="$t('job-board.settings.meta_data.about')"
            v-model="jobBoard.meta_data.about"
         />
      </div>
      <div class="row">
         <NxtInput
            name="job-board_settings_meta_keywords"
            :label="$t('job-board.settings.meta_data.keywords')"
            :description="$t('job-board.settings.meta_data.keywords_description')"
            v-model="jobBoard.meta_data.keywords"
         />
      </div>
      <div class="row">
         <NxtInput
            name="job-board_settings_meta_open_graph"
            :label="$t('job-board.settings.meta_data.open_graph')"
            :description="$t('job-board.settings.meta_data.open_graph_description')"
            v-model="jobBoard.meta_data.open_graph"
         />
      </div>
   </section>
</template>
